exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* don't use colors.css and friends as the theme system is not set up when this is used */\r\n\r\n.invalid-embed_container_3-VXo {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto;\r\n\r\n    /* this is an error, so we want it to stand out and always be readable regardless of what the site */\r\n    /* embedding us looks like */\r\n    background-color: #ff4c4c;\r\n    color: white;\r\n\r\n    box-sizing: border-box;\r\n    padding: 8px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.invalid-embed_code_lq9SI {\r\n    font-family: monospace;\r\n}\r\n\r\n.invalid-embed_emphasis_3umem {\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "invalid-embed_container_3-VXo",
	"code": "invalid-embed_code_lq9SI",
	"emphasis": "invalid-embed_emphasis_3umem"
};